import { useTranslation } from 'next-i18next'

import DropdownMenu from '~/components/DropdownMenu/DropdownMenu'
import { Checkbox } from '~/components'
import { Subject } from '~/types/booking'
import { capitalize } from '~/utils'

export default function SelectSubjects({
  onClick,
  subjects,
  error = '',
}: {
  onClick: (subjects: Subject[]) => void
  subjects: Subject[]
  error?: string | undefined
}): React.ReactElement {
  const { t } = useTranslation('booking')

  const handleOnClick = (item: Subject): void => {
    onClick(subjects.includes(item) ? subjects.filter((subject) => subject !== item) : [...subjects, item])
  }

  const header = subjects.length
    ? subjects
        .map((subject) => t(`subjects.${subject}`))
        .map(capitalize)
        .join(', ')
    : t('subjects.title')

  return (
    <DropdownMenu error={error} header={header}>
      <div className="space-y-1">
        {Object.values(Subject).map((subject) => (
          <Checkbox
            id={subject}
            isChecked={subjects.includes(subject)}
            key={subject}
            labelClassName="!text-sm text-black-light"
            onChange={() => handleOnClick(subject)}
            text={t(`subjects.${subject}`)}
          />
        ))}
      </div>
    </DropdownMenu>
  )
}
